import React, { Component } from "react";
import { Menu, Icon } from "semantic-ui-react";
import { Input } from "semantic-ui-react";
import moment from "moment";
const math = require("mathjs");
class TimeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: null,
      value: props.hours,
      method: null,
      edited: false,
      laborentry: props.laborentry
    };
  }
  componentDidUpdate(prevProps, prevState) {
    console.log();
    if (this.state.value !== this.props.hours && this.state.edited === false) {
      this.setState({
        value: this.props.hours
      });
    }
  }

  geninput() {
    if (
      !this.props.movetime &&
      (this.props.readonly ||
        this.props.printable ||
        this.props.blackedOut)
    ) {
      return <p id="blackedOutLabor">{this.props.laborentry.hours}</p>;
    } else {
      return (
        <Input
          id="timeInput"
          size="mini"
          type="number"
          min="0"
          max="24"
          value={this.state.value}
          onKeyPress={this.handlekeypress}
          onChange={e => this.handleChange(e)}
          onBlur={() => this.handleUpdate()}
        />
      );
    }
  }

  handleUpdate() {
    let job = this.props.job;
    this.setState({
      edited: false
    });
    console.log(this.state.roundedhours);
    this.props.timeupdate({
      ...this.props.laborentry,
      hours: this.state.formatvalue
    });
  }
  handleChange = e => {
    console.log(this.props.laborentry);
    var math = require("mathjs");
    var hours = Number(e.target.value);
    var roundedhours = Number(math.round(hours + "e2") + "e-2");
    console.log("roundedhours " + roundedhours);
    let newentry = {
      ...this.props.laborentry,
      backuphours: this.props.laborentry.hours,
      hours: roundedhours
    };
    console.log("movetime", newentry);
    this.setState({
      value: e.target.value,
      edited: true,
      formatvalue: roundedhours,
      laborentry: newentry
    });
    this.props.handleInputchange(newentry);
  };
  render() {
    return <div className="TimeInput"> {this.geninput()} </div>;
  }
}

export default TimeInput;



// WEBPACK FOOTER //
// ./src/components/shared-components/timesheet/timeinput.js